import { render } from "./DashboardBoxText.vue?vue&type=template&id=905c9af8"
import script from "./DashboardBoxText.vue?vue&type=script&lang=js"
export * from "./DashboardBoxText.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__